import { ArrowRight } from 'lucide-react'
import { InteractiveSystemMap } from '../components/InteractiveSystemMap'
import { PageHero } from '../components/PageHero'
import { PageMeta } from '../components/PageMeta'
import { SolutionExplorer } from '../components/SolutionExplorer'

export function SolutionsPage() {
  return (
    <main id="main-content" className="route-page">
      <PageMeta
        title="Business technology solutions"
        description="Explore Informat solutions across business foundations, cloud, CRM, phones, networks, websites, backup, AI, automation, security and identity."
      />
      <PageHero
        className="solutions-hero"
        title={
          <>
            Solutions for the way
            <br />
            your business works.<span className="text-cursor" aria-hidden="true" />
          </>
        }
        body="From the essentials that keep people connected to the systems that support growth, Informat brings the right pieces together around your business."
        primary={{ href: '#solution-explorer-title', label: 'Explore solutions' }}
        secondary={{ href: '/contact', label: 'Discuss your needs' }}
        visual={<InteractiveSystemMap />}
      />
      <SolutionExplorer />
      <section className="engagement-note section-dark">
        <p>
          The right level of engagement depends on the system, the project and what your business
          needs.
        </p>
        <a href="/approach">
          How we work <ArrowRight aria-hidden="true" />
        </a>
      </section>
    </main>
  )
}
